import type {
  EnumDeviceDiagnosticsTypeApi,
  EnumDiagnosticTestExecutionStatusApi,
  EnumDiagnosticTestModuleApi,
  PaginatedListResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';

export interface MappedDiagnosticsResourceApi {
  readonly date: Date;
  readonly deviceId: string;
  readonly id: string;
  readonly serialNumber: string;
  readonly testResults: DeviceResourceDiagnosticsTestResult[];
  readonly type: EnumDeviceDiagnosticsTypeApi;
}

export enum DeviceDiagnosticsType {
  AutomaticDiagnostics = 'AUTOMATIC_DIAGNOSTICS',
  ManualDiagnostics = 'MANUAL_DIAGNOSTICS',
}

export const enumDiagnosticTestStatus = {
  FAILED: 'FAILED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  PASSED: 'PASSED',
  WARNING: 'WARNING',
} as const;
export type DiagnosticTestStatus = (typeof enumDiagnosticTestStatus)[keyof typeof enumDiagnosticTestStatus];

export const enumDiagnosticTestModule = {
  AUDIO: 'AUDIO',
  BATTERY: 'BATTERY',
  BLUETOOTH: 'BLUETOOTH',
  CAMERA_BACK: 'CAMERA_BACK',
  CAMERA_FRONT: 'CAMERA_FRONT',
  CELLULAR: 'CELLULAR',
  CERTIFICATES: 'CERTIFICATES',
  DISPLAY: 'DISPLAY',
  ETHERNET: 'ETHERNET',
  KEYBOARD: 'KEYBOARD',
  LED: 'LED',
  MAG_STRIPE_READER: 'MAG_STRIPE_READER',
  NFC_READER: 'NFC_READER',
  PRINTER: 'PRINTER',
  SMART_CARD_READER: 'SMART_CARD_READER',
  VIRTUAL_KEYBOARD: 'VIRTUAL_KEYBOARD',
  WIFI: 'WIFI',
} as const;
export type DiagnosticTestModule = (typeof enumDiagnosticTestModule)[keyof typeof enumDiagnosticTestModule];

export enum DiagnosticTestExecutionStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  NotApplicable = 'NOT_APPLICABLE',
}

export interface DeviceResourceDiagnosticsTestResult {
  readonly resultCode: string;
  readonly errorCode: string;
  readonly executionStatus: EnumDiagnosticTestExecutionStatusApi;
  readonly module: EnumDiagnosticTestModuleApi;
  readonly status: DiagnosticTestStatus;
}

export type MappedDiagnosticsResourceListResponseApi = PaginatedListResponseApi & {
  readonly data: MappedDiagnosticsResourceApi[];
};
